/* Moomo R2 · hero carousel: crossfade, replays each hero's collage motion on entry, dots/arrows/swipe/keys,
   auto-advance that pauses on hover, focus or the pause button, and never runs for reduced motion. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const play = (slide) => {
    slide.querySelectorAll('.mh, .mhc').forEach((hero) => {
      hero.classList.remove('is-in'); void hero.offsetWidth; hero.classList.add('is-in');
    });
  };
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const slides = [...root.querySelectorAll('[data-mm-slide]')];
    const dotsWrap = root.querySelector('[data-mm-hs-dots]');
    const pauseBtn = root.querySelector('[data-mm-hs-pause]');
    const interval = (parseInt(root.dataset.interval, 10) || 8) * 1000;
    let index = 0; let timer = null; let userPaused = false; let hover = false; let focus = false; let visible = true;
    if (slides.length < 2) { root.classList.add('is-single'); }
    const dots = slides.map((s, i) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'mm-hs__dot';
      b.setAttribute('aria-label', `Slide ${i + 1} of ${slides.length}: ${s.getAttribute('aria-label')}`);
      b.addEventListener('click', () => go(i, true));
      dotsWrap.appendChild(b);
      return b;
    });
    const running = () => !userPaused && !hover && !focus && visible && !reduce.matches && slides.length > 1;
    const schedule = () => { clearTimeout(timer); if (running()) timer = setTimeout(() => go(index + 1), interval); };
    const go = (i, user) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        const on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach((d, n) => d.setAttribute('aria-current', n === index ? 'true' : 'false'));
      if (visible) play(slides[index]);
      if (user) root.querySelector('.mm-hs__track').setAttribute('aria-live', 'polite');
      schedule();
    };
    root.querySelector('[data-mm-hs-prev]').addEventListener('click', () => go(index - 1, true));
    root.querySelector('[data-mm-hs-next]').addEventListener('click', () => go(index + 1, true));
    pauseBtn.addEventListener('click', () => {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', String(userPaused));
      pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
      root.classList.toggle('is-paused', userPaused);
      schedule();
    });
    root.addEventListener('mouseenter', () => { hover = true; schedule(); });
    root.addEventListener('mouseleave', () => { hover = false; schedule(); });
    root.addEventListener('focusin', () => { focus = true; schedule(); });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { focus = false; schedule(); } });
    root.addEventListener('keydown', (e) => {
      if (!e.target.closest('.mm-hs__controls')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
    });
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1), true);
    });
    if ('IntersectionObserver' in window) {
      let first = true;
      new IntersectionObserver(([en]) => {
        visible = en.isIntersecting;
        if (visible && first) { first = false; play(slides[index]); }
        schedule();
      }, { threshold: 0.25 }).observe(root);
    }
    document.addEventListener('visibilitychange', () => { visible = !document.hidden; schedule(); });
    reduce.addEventListener('change', schedule);
    go(0);
  };
  const boot = () => document.querySelectorAll('[data-mm-hs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
